import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { COST_PREVIEW_REGISTER_STUDENT } from "@constants/api";
import { AlertResultApi } from "@utils/alert";
import { fetching, FetchingEnum } from "./Fetching";

export const initialStateCalculationCost = {
  fetchingCostStudent: FetchingEnum.DONE,
};

const Transaction = types.model({
  fromDate: types.string,
  toDate: types.string,
  price: types.number,
  total: types.number,
  type: types.string,
});

const CostStudent = types.model({
  rateChart: types.model({
    id: types.number,
    name: types.string,
  }),
  transactions: types.maybeNull(types.array(Transaction)),
});

export const CalculationCost = types
  .model({
    transactionsCostStudent: types.maybeNull(types.array(CostStudent)),
    fetchingCostStudent: fetching,
    statusCostStudent: types.maybeNull(types.number),
  })
  .actions((self) => ({
    initialCaluclationCost: () => {
      self.fetchingCostStudent = FetchingEnum.DONE;
      self.transactionsCostStudent = null;
      self.statusCostStudent = null;
    },
    postCalculationStudent: flow(function* postregisterStudent(
      token: string,
      data: RegisterStudentType,
      callback: () => void
    ) {
      self.fetchingCostStudent = FetchingEnum.PENDING;
      self.transactionsCostStudent = null;
      self.statusCostStudent = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "post",
          url: COST_PREVIEW_REGISTER_STUDENT,
          headers: { Authorization: `Bearer ${token}` },
          data: data,
        });
        console.log("postregisterStudent", result);
        self.fetchingCostStudent = FetchingEnum.DONE;
        self.statusCostStudent = result.status;
        self.transactionsCostStudent = result.data;
        callback();
      } catch (error) {
        // ... including try/catch error handling
        // console.tron.log('Failed to fetch projects', error);
        self.fetchingCostStudent = "error";
        self.statusCostStudent = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
  }));

export type CostStudentType = Instance<typeof CostStudent>;
